import { render, staticRenderFns } from "./reaktionen.vue?vue&type=template&id=5e62cdf4&"
import script from "./reaktionen.vue?vue&type=script&lang=js&"
export * from "./reaktionen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports